<template>
  <v-app id="inspire">
    <v-toolbar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      color="primary"
      dark
      app
      fixed
    >
      <v-toolbar-title style="width: 300px" class="xs-0 ml-0 pl-3">
        <span>Privacy Policy</span>
      </v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <p class="text-xs-right ma-0">Last Updated: February 21, 2019</p>
        <p class="text-xs-right">NEC Corporation</p>

        <p>NEC believes that data privacy and protection are important issues.</p>
        <p>At NEC, we are committed to protecting your personal information and being transparent about the collection and processing of personal data.</p>
        <p>This Privacy Policy describes NEC's practices in connection with information that NEC collects through online and offline activities.</p>
        <p>NEC may collect your business contact information such as name, business contact details, position or title from offline registration form that NEC collects via events or other promotions.</p>

        <h1>Controller of the Personal Data</h1>
        <ul>
          <li>NEC Corporation (hereinafter referred to as "NEC")</li>
          <li>Means of contact: This website of nec.com</li>
        </ul>

        <h1>Purposes of Processing for the Personal Data</h1>
        <ul>
          <li>To respond to inquiries.</li>
          <li>To respond to requests (such as by providing materials or information, or returning verification results).</li>
          <li>To introduce or relay information about companies (NEC Group companies, NEC distributors, etc.) that deal with NEC products, services, and solutions.</li>
          <li>To provide information or publicity materials about NEC products, services, and solutions.</li>
          <li>To provide information about events such as seminars and exhibitions.</li>
          <li>To conduct surveys and analysis, and analyze website access trends so as to improve products and services.</li>
          <li>To contact customers.</li>
        </ul>

        <h1>Sharing of Personal Data</h1>
        <p>NEC will share personal data with NEC Group Companies and/or NEC distributors in case it is necessary to fulfil Purposes of Processing for the Personal Data described above.</p>

        <h1>Overseas Transfer of the Personal Data</h1>
        <p>NEC manages and operates this inquiry site in Japan.</p>
        <ul>
          <li>Your personal data will be sent to Japan when you agree to the submission of personal data entered into forms such as for contacts and inquiries.</li>
          <li>As of January 23rd, 2019, Japan has been recognized by the European Commission as providing adequate protection of personal data.</li>
          <li>NEC manages the personal data with which it is entrusted through the appropriate implementation of security measures such as access identification and authentication, restrictions on access, authority management, record-keeping, protection against illegal software, and safe procedures for transferring and transmitting data.</li>
        </ul>

        <h1>Categories of the Personal Data</h1>
        <p>Personal data includes name, occupation, organization name, e-mail address, telephone number, postal address, residential country or area, inquiry categories, inquiry subject, inquiry details, access logs, cookies and other information collected upon your visit to this website.</p>

        <h1>Period for Which the Personal Data Will Be Stored</h1>
        <p>Personal data may be stored for as long as necessary to achieve the stated purpose for using it.</p>

        <h1>Rights of the Data Subject</h1>
        <p>You have the right with regard to the personal data which you provide as follows:</p>
        <p>By offering various Internet-related products, services, and solutions, NEC Corporation ("NEC") contributes to society as a global leading company which realizes an "information society friendly to humans and the earth" through innovation.</p>
        <p>In working toward the realization of such a society, NEC recognizes that the protection of personal information is its social responsibility, and has established a policy for the protection of personal information. Efforts are constantly being made to implement and maintain the policy. This privacy policy sets forth our principles as follows (note that the original is in Japanese):</p>
        <ul>
          <li>The right to request from the controller access to and rectification or erasure of personal data or restriction of processing concerning the data subject</li>
          <li>The right to object to processing concerning the data subject</li>
          <li>The right to data portability: The right to receive the personal data, which the data subject has provided to a data controller, in a structured, commonly used and machine-readable format, and to transmit those data to another data controller without hindrance from the controller to which the personal data have been provided (NEC)</li>
          <li>The right to withdraw consent at any time, without affecting the lawfulness of processing based on consent before its withdrawal</li>
          <li>The right to lodge a complaint with a supervisory authority, if it exists, in the country or region that the data object belongs.</li>
        </ul>

        <h1>Statutory or Contractual Requirement Concerning the Provision of the Personal Data</h1>
        <p>Provision of the personal data is not a statutory or contractual requirement, or a requirement necessary to enter into a contract, and you are not obliged to provide personal data. However, if you choose not to provide personal data, it may not be possible to respond to some inquiries.</p>

        <h1>Non-existence of Decision-making Based Solely on Automated Processing</h1>
        <p>The access log for this website undergoes analysis, however, we do not make decisions that might affect you based solely on automated processing of the personal data that you provide, including profiling, in order to analyze or predict your likes and dislikes or personal behavior.</p>

        <h1>Parental Consent</h1>
        <p>If you are under the age of 16, please make sure you provide your personal data to NEC ONLY AFTER obtaining consent given or authorized by the holder of parental responsibility over you.</p>

        <h1>Security of Processing the Personal Data</h1>
        <p>Recipients of the personal data implement appropriate technical and organizational measures to ensure a level of security appropriate to the risk.</p>

        <h1>Cookies</h1>
        <ul>
          <li>What are cookies</li>
            <p>A cookie is a small piece of data that a website asks your browser to store on your computer or mobile device. The cookie helps to distinguish you from other users of NEC's Website and they are used for many things, such as remembering when you've visited a site before and your language preferences.</p>
            <p>The information NEC collects by using cookies also permits NEC to analyze traffic patterns on our site. This can enable NEC over time to provide you with a better experience on its Website by improving the content and making it easier to use.
            <p>While a cookie enables a Web server to identify the computer of a visitor, it cannot identify the visitor unless they input their personal information. Depending on the browser used, a visitor may change the settings to turn off the cookies. However, if the visitor does so, all or part of the services on the site may become unavailable.</p>
          <li>Functionality/Essential cookies</li>
            <p>These cookies are necessary to provide you with services available through NEC's Website and to use some of its features, such as access to secure areas. Without these cookies, services you have asked for, like secure login accounts, may not be possible.
Analytic    al/Performance cookies</p>
            <p>These cookies are used to collect information about how you use our site. They allow NEC's Website to improve and provide the most relevant information to you. NEC uses Google Analytics and Adobe Analytics, which are a web analytics service to collect and report website traffic.</p>
          <li>Targeting cookies</li>
            <p>These cookies are used to record your visit to NEC's Website to deliver content that best suits your interests. NEC may use these cookies for marketing purposes such as targeted advertising/offers, and promotional campaigns.</p>
          <li>Social Plugin cookies</li>
            <p>These cookies create a link between your visit to NEC's Website and the social media platforms such as Facebook, Twitter, YouTube and LinkedIn. These cookies allow such social media platform providers to know that you have visited NEC's Website.</p>
          <li>How to manage cookies</li>
            <p>If you disagree to the use of cookies, you can deactivate and/or delete cookies through your browser. Please note that if you use your browser settings to block all cookies, you may not be able to access or use all the functionalities of NEC's Website.</p>
            <p>For further information about how to do so, please refer to your browser settings 'help' / 'tool', 'option', or 'edit' section.</p>
            <p>You can exercise your choice in allowing for cookies to be placed on your computer or to opt-out of cookies by using online tools, such as new windowhttp://www.allaboutcookies.org/manage-cookies/index.html if you are located in the US, or new windowhttp://www.aboutads.info/choices/ if you are located in Europe.</p>
            <p>The above websites are not NEC's Websites and NEC is not responsible for their content.</p>
        </ul>

        <h1>Web beacons</h1>
        <p>On NEC's Websites, there are pages where a technology called "Web beacons" ("clear GIF") is used. The beacons help us to determine how many times a page has been viewed. Statistical data collected by Web beacons is generally used to improve NEC's Websites.</p>

        <h1>Statistical tools</h1>
        <p>On NEC's Websites, there are pages where a tool is generally used to perform statistical analyses of user behavior. Information collected by this statistical tool is generally used to improve NEC's Websites.</p>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    data: () => ({
    }),
    props: {
    }
  }
</script>

<style>
  #inspire {
    font-size: 14pt;
  }

  #inspire h1 {
    font-size: 20pt;
    margin-top: 10pt;
  }
</style>
